import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
Amplify.configure(awsconfig)
Vue.use(AmplifyPlugin, AmplifyModules)

import 'vue-awesome/icons/filter'
import 'vue-awesome/icons/sort-alpha-down'
import 'vue-awesome/icons/sort-alpha-down-alt'
import Icon from 'vue-awesome/components/Icon.vue'
Vue.component('v-icon', Icon)

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
